/**
 * Socket.IO 이벤트 이름 상수.
 * 클라이언트와 서버 모두 이 상수를 import해 사용한다.
 */

export const ClientToServer = {
  ROOM_CREATE: 'room:create',
  ROOM_JOIN: 'room:join',
  ROOM_LEAVE: 'room:leave',
  ROOM_KICK: 'room:kick',
  ROOM_START: 'room:start',
  ROOM_RESTART: 'room:restart',
  GAME_MOVE: 'game:move',
  /**
   * dev-only: 게임을 즉시 FINISHED로 만들어 결과 화면 흐름 테스트.
   * production 서버 빌드에서는 핸들러가 등록되지 않으므로 무시된다.
   */
  DEBUG_FORCE_FINISH: 'debug:force-finish',
  PING: 'ping:client',
} as const;

export type ClientToServerEvent = (typeof ClientToServer)[keyof typeof ClientToServer];

export const ServerToClient = {
  ROOM_STATE: 'room:state',
  ROOM_ERROR: 'room:error',
  ROOM_GAME_STARTING: 'room:game-starting',
  GAME_STATE: 'game:state',
  GAME_ERROR: 'game:error',
  CONNECTION_REPLACED: 'connection:replaced',
  HELLO: 'hello',
  PONG: 'pong:server',
} as const;

export type ServerToClientEvent = (typeof ServerToClient)[keyof typeof ServerToClient];
